import clsx from "clsx";
import Modal, { ModalProps } from "components/Modal";
import React from "react";
import ModalTitle from "./components/ModalTitle";
import { epdSearchStore } from "features/EPDSearchModal/EPDSearchStore";
import { observer } from "mobx-react-lite";
import EPDSearchContent from "./features/EPDSearchContent";

interface ProductEditorEPDSearch extends ModalProps {
  datasetIndex?: number;
  rowIndex?: number;
  searchTerm?: string;
  generate?: boolean;
}

const EPDSearchModal = (props: ProductEditorEPDSearch) => {
  return (
    <Modal
      isOpen={props.open}
      setIsOpen={props.close}
      className="p-6 relative"
      containerClassName={clsx(
        "md:min-w-[1280px] max-w-[1280px] min-h-[500px] overflow-visible overflow-x-hidden",
        {
          "min-h-[calc(100vh-70px)] !max-h-auto":
            epdSearchStore.isExternalSearch,
        }
      )}
      position="top"
      title={<ModalTitle />}
      titleClassName="w-full justify-between"
      headerClassName={`${
        epdSearchStore.isExternalSearch ? "bg-gray-100" : "bg-white"
      } text-gray-900 h-[60px]`}
      closeButton
    >
      <EPDSearchContent
        open={props.open}
        close={props.close}
        datasetIndex={props.datasetIndex}
        rowIndex={props.rowIndex}
        searchTerm={props.searchTerm}
        generate={props.generate}
      />
    </Modal>
  );
};

export default observer(EPDSearchModal);
